import { useEffect, useState } from "react";
import Breadcrumb from "../../components/common/Breadcrumb";
import { Container } from "react-bootstrap";

export default function KIYGResults() {
  const [results, setResults] = useState([]);
  const [totals, setTotals] = useState({
    gold: 0,
    silver: 0,
    bronze: 0,
    total: 0,
  });

  useEffect(() => {
    async function fetchData() {
      const response = await fetch("data/kiyg25-medals.json");
      const data = await response.json();
      setResults(data);

      // Calculate totals
      const totalGold = data.reduce((sum, item) => sum + item.gold, 0);
      const totalSilver = data.reduce((sum, item) => sum + item.silver, 0);
      const totalBronze = data.reduce((sum, item) => sum + item.bronze, 0);
      const totalMedals = totalGold + totalSilver + totalBronze;

      setTotals({
        gold: totalGold,
        silver: totalSilver,
        bronze: totalBronze,
        total: totalMedals,
      });
    }
    fetchData();
  }, []);

  return (
    <div>
      <Breadcrumb
        pageName={KIYGResults}
        pageTitle={"Khelo India Youth Games 2025"}
        img_url={"img/kiyg25-banner.jpg"}
        mobile_banner={"img/kiyg25-mobile.jpg"}
      />
      <Container style={{ overflow: "auto", padding: "20px" }}>
        <h1 className="text-center">Medal Tally</h1>
        <br />
        <div className="row">
          <div className="col-xs-6">
            <a
              href="https://youth.kheloindia.gov.in/medal-tally"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button
                style={{
                  background: "blue",
                  color: "white",
                  width: "100%",
                  padding: "1%",
                  margin: "1%",
                  borderRadius: 10,
                }}
              >
                Generic Medal Tally
              </button>
            </a>
          </div>
          <div className="col-xs-6">
            <a
              href="https://youth.kheloindia.gov.in/medal-tally/sport-wise"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button
                style={{
                  background: "blue",
                  color: "white",
                  width: "100%",
                  padding: "1%",
                  margin: "1%",
                  borderRadius: 10,
                }}
              >
                Sports Wise Medal Tally
              </button>
            </a>
          </div>
        </div>
        <br />
        <h3 className="text-center">Bihar's Performance</h3>
        <br />
        <table className="table table-bordered">
          <thead>
            <tr>
              <th style={{ textAlign: "center" }}>Sports</th>
              <th style={{ textAlign: "center" }}>🥇 Gold</th>
              <th style={{ textAlign: "center" }}>🥈 Silver</th>
              <th style={{ textAlign: "center" }}>🥉 Bronze</th>
              <th style={{ textAlign: "center" }}>Total</th>
            </tr>
          </thead>
          <tbody>
            {results.map((result, index) => (
              <tr key={index}>
                <td>{result.game.en}</td>
                <td>{result.gold}</td>
                <td>{result.silver}</td>
                <td>{result.bronze}</td>
                <td>{result.gold + result.silver + result.bronze}</td>
              </tr>
            ))}
            {/* Add totals row */}
            <tr style={{ fontWeight: "bold", background: "#f0f0f0" }}>
              <td style={{ textAlign: "center" }}>Grand Total</td>
              <td style={{ textAlign: "center" }}>{totals.gold}</td>
              <td style={{ textAlign: "center" }}>{totals.silver}</td>
              <td style={{ textAlign: "center" }}>{totals.bronze}</td>
              <td style={{ textAlign: "center" }}>{totals.total}</td>
            </tr>
          </tbody>
        </table>
      </Container>
    </div>
  );
}
